module.exports = __webpack_public_path__ + "img/cattunnel29.d9202318.jpg";